/**
 * @enum {string}
 */
const FootballState = Object.freeze({
    SkipKickoff: "SKIP_KICKOFF",
    Start: "START",
    AddPlay: "ADD_PLAY",
    Rush: "RUSH",
    EndOfPlay: "END_OF_PLAY",
    NoPenaltyEndOfPlay: "NO_PENALTY_END_OF_PLAY",
    OutOfBounds: "OUT_OF_BOUNDS",
    Muffed: "MUFFED",
    Fumble: "FUMBLE",
    FumbleRecovered: "FUMBLE_RECOVERED",
    FumbleNotRecovered: "FUMBLE_NOT_RECOVERED",
    Tackle: "TACKLE",
    Continue: "CONTINUE",
    Returned: "RETURNED",
    Finalize: "FINALIZE",
    Timeout: "TIMEOUT",
    Safety: "SAFETY",
    Lateral: "LATERAL",
    Spike: "SPIKE",
    KneelDown: "KNEELDOWN",
    // Fumbled Snap
    FumbledSnap: "FUMBLED_SNAP",
    FumbledSnapLost: "FUMBLED_SNAP_LOST",
    FumbledSnapRecovered: "FUMBLED_SNAP_RECOVERED",
    // Dead ball with no player involved - flag football only, after a
    // fumbled snap. See fragments/dead-ball.js.
    DeadBall: "DEAD_BALL",
    //PENALTIES
    Penalty: "PENALTY",
    SecondPenalty: "SECOND_PENALTY",
    PenaltyAccepted: "PENALTY_ACCEPTED",
    PenaltyDeclined: "PENALTY_DECLINED",
    Offsetting: "OFFSETTING",
    SecondOffsetting: "SECOND_OFFSETTING",
    StatsCount: "STATS_COUNT",
    NoPlay: "NO_PLAY",
    //PLAY PENALTIES
    PlayPenalty: "PLAY_PENALTY",
    PlayPenaltySecondPenalty: "PLAY_PENALTY_SECOND_PENALTY",
    PlayPenaltyPenaltyAccepted: "PLAY_PENALTY_PENALTY_ACCEPTED",
    PlayPenaltyPenaltyDeclined: "PLAY_PENALTY_PENALTY_DECLINED",
    PlayPenaltyOffsetting: "PLAY_PENALTY_OFFSETTING",
    PlayPenaltySecondOffsetting: "PLAY_PENALTY_SECOND_OFFSETTING",
    PlayPenaltyNoPlay: "PLAY_PENALTY_NO_PLAY",
    PlayPenaltyStatsCount: "PLAY_PENALTY_STATS_COUNT",
    //PAT
    PatTry: "PAT_TRY",
    DropKick: "DROP_KICK",
    PatKick: "PAT_KICK",
    PatPass: "PAT_PASS",
    PatReturned: "PAT_RETURNED",
    PatContinued: "PAT_CONTINUED",
    PatRecovered: "PAT_RECOVERED",
    PatNotRecovered: "PAT_NOT_RECOVERED",
    PatPointsAwarded: "PAT_POINTS_AWARDED",
    PatPointsNotAwarded: "PAT_POINTS_NOT_AWARDED",
    Run: "RUN",
    PatBlocked: "PAT_BLOCKED",
    PatCompleted: "PAT_COMPLETED",
    PatMissed: "PAT_MISSED",
    PatFumbled: "PAT_FUMBLED",
    PatIntercepted: "PAT_INTERCEPTED",
    //KICK
    Kick: "KICK",
    CflKick: "CFL_KICK",
    KickOff: "KICK_OFF",
    //DEUCE (Indoor Football - kickoff through uprights)
    Deuce: "DEUCE",
    DeuceGood: "DEUCE_GOOD",
    DeuceMissed: "DEUCE_MISSED",
    //REBOUND NET (Indoor Football - ball hits net and stays live)
    HitReboundNet: "HIT_REBOUND_NET",
    ReboundNetCaughtOffense: "REBOUND_NET_CAUGHT_OFFENSE",
    ReboundNetCaughtDefense: "REBOUND_NET_CAUGHT_DEFENSE",
    ReboundNetHitGround: "REBOUND_NET_HIT_GROUND",
    ReboundNetFieldedKicking: "REBOUND_NET_FIELDED_KICKING",
    ReboundNetFieldedReceiving: "REBOUND_NET_FIELDED_RECEIVING",
    //BAR BALL (Indoor Football - kickoff hits goalpost)
    HitGoalpost: "HIT_GOALPOST",
    BarBallRecoveredKicking: "BAR_BALL_RECOVERED_KICKING",
    BarBallRecoveredReceiving: "BAR_BALL_RECOVERED_RECEIVING",
    KickOffPenalty: "KICK_OFF_PENALTY",
    KickOffPenaltyAccepted: "KICK_OFF_PENALTY_ACCEPTED",
    KickOffPenaltyDeclined: "KICK_OFF_PENALTY_DECLINED",
    Rouge: "ROUGE",
    Downed: "DOWNED",
    TouchBack: "TOUCH_BACK",
    FairCatch: "FAIR_CATCH",
    KickRecovered: "KICK_RECOVERED",
    KickNotRecovered: "KICK_NOT_RECOVERED",
    OnSide: "ON_SIDE",
    NoRecoveryKickReturn: "NO_RECOVERY_KICK_RETURN",
    FieldGoal: "FIELD_GOAL",
    FieldGoalFumble: "FIELD_GOAL_FUMBLE",
    FieldGoalFakeRun: "FIELD_GOAL_FAKE_RUN",
    FieldGoalFakePass: "FIELD_GOAL_FAKE_PASS",
    FieldGoalGood: "FIELD_GOAL_GOOD",
    FieldGoalMissed: "FIELD_GOAL_MISSED",
    FieldGoalBlocked: "FIELD_GOAL_BLOCKED",
    FieldGoalOutOfBounds: "FIELD_GOAL_OUT_OF_BOUNDS",
    //PUNT
    Punt: "PUNT",
    PuntBlocked: "PUNT_BLOCKED",
    PuntOutOfBounds: "PUNT_OUT_OF_BOUNDS",
    //PASS
    Pass: "PASS",
    PassIncomplete: "PASS_INCOMPLETE",
    PassBrokenUp: "PASS_BROKEN_UP",
    PassDropped: "PASS_DROPPED",
    PassSacked: "PASS_SACKED",
    PassIntercepted: "PASS_INTERCEPTED",
    PassComplete: "PASS_COMPLETE",
    //GAME CONTROL
    GameControl: "GAME_CONTROL",
    StartDrive: "START_DRIVE",
    GameStart: "GAME_START",
    StartPeriod: "START_PERIOD",
    UpdateContext: "UPDATE_FIELD",
    CoinToss: "COIN_TOSS",
    SwapTeams: "SWAP_TEAMS",
    SetTimeAndPeriod: "SET_TIME_AND_PERIOD"
});

export default FootballState;
